/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES プレスリリースエディタ API
 * PR TIMES 企業管理画面 プレスリリースエディタ用の API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    PressReleaseRequestParams,
    PressReleaseRequestParamsFromJSON,
    PressReleaseRequestParamsFromJSONTyped,
    PressReleaseRequestParamsToJSON,
} from './PressReleaseRequestParams';

/**
 * プレスリリース更新APIのリクエストボディ
 * @export
 * @interface UpdatePressReleaseRequestBody
 */
export interface UpdatePressReleaseRequestBody {
    /**
     * 
     * @type {PressReleaseRequestParams}
     * @memberof UpdatePressReleaseRequestBody
     */
    pressRelease: PressReleaseRequestParams;
    /**
     * csrf_token
     * @type {string}
     * @memberof UpdatePressReleaseRequestBody
     */
    csrfToken: string;
    /**
     * コンフリクト検知用のタイムスタンプ
     * @type {number}
     * @memberof UpdatePressReleaseRequestBody
     */
    editStartedAt: number;
    /**
     * 企業id
     * @type {number}
     * @memberof UpdatePressReleaseRequestBody
     */
    companyId: number;
    /**
     * コンフリクトした場合に強制実行する
     * @type {boolean}
     * @memberof UpdatePressReleaseRequestBody
     */
    isForceMode?: boolean;
    /**
     * テストメールを送信フラグ
     * @type {boolean}
     * @memberof UpdatePressReleaseRequestBody
     */
    shouldSendTestMail?: boolean;
    /**
     * テストメール送信先
     * @type {string}
     * @memberof UpdatePressReleaseRequestBody
     */
    testMailAddress?: string;
}

export function UpdatePressReleaseRequestBodyFromJSON(json: any): UpdatePressReleaseRequestBody {
    return UpdatePressReleaseRequestBodyFromJSONTyped(json, false);
}

export function UpdatePressReleaseRequestBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdatePressReleaseRequestBody {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'pressRelease': PressReleaseRequestParamsFromJSON(json['press_release']),
        'csrfToken': json['csrf_token'],
        'editStartedAt': json['edit_started_at'],
        'companyId': json['company_id'],
        'isForceMode': !exists(json, 'is_force_mode') ? undefined : json['is_force_mode'],
        'shouldSendTestMail': !exists(json, 'should_send_test_mail') ? undefined : json['should_send_test_mail'],
        'testMailAddress': !exists(json, 'test_mail_address') ? undefined : json['test_mail_address'],
    };
}

export function UpdatePressReleaseRequestBodyToJSON(value?: UpdatePressReleaseRequestBody | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'press_release': PressReleaseRequestParamsToJSON(value.pressRelease),
        'csrf_token': value.csrfToken,
        'edit_started_at': value.editStartedAt,
        'company_id': value.companyId,
        'is_force_mode': value.isForceMode,
        'should_send_test_mail': value.shouldSendTestMail,
        'test_mail_address': value.testMailAddress,
    };
}

